import { purple } from '@mui/material/colors';
import type { SxProps, Theme } from '@mui/material/styles';
import SvgIcon from '@mui/material/SvgIcon';
import { keyframes } from '@mui/system';

import { mergeSx } from '@/utils/mergeSx';

const spinAnimation = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

type Props = {
	sx?: SxProps<Theme>;
	fill?: string;
	spin?: boolean;
};

export const ProcessingIcon = ({ sx, fill, spin = false }: Props) => {
	return (
		<SvgIcon
			width='24'
			height='24'
			viewBox='0 0 24 24'
			fill='none'
			sx={mergeSx(
				{
					animation: spin ? `${spinAnimation} 2s linear infinite` : undefined
				},
				sx
			)}
		>
			<path
				d='M12 6v3l4-4-4-4v3c-4.42 0-8 3.58-8 8 0 1.57.46 3.03 1.24 4.26L6.7 14.8c-.45-.83-.7-1.79-.7-2.8 0-3.31 2.69-6 6-6m6.76 1.74L17.3 9.2c.44.84.7 1.79.7 2.8 0 3.31-2.69 6-6 6v-3l-4 4 4 4v-3c4.42 0 8-3.58 8-8 0-1.57-.46-3.03-1.24-4.26'
				fill={fill ?? purple[800]}
			/>
		</SvgIcon>
	);
};
